import { mapActions } from 'vuex';
import ErrorMessage from './error-messages/component.vue';
import PageWelcome from './page-welcome/component.vue';
import PageCalling from './page-calling/component.vue';
import PagePickup from './page-pickup/component.vue';
import PageCallEnd from './page-call-end/component.vue';
import PageLeaveMessage from './page-leave-message/component.vue';
import PageAfterCallback from './page-after-callback/component.vue';
import PageChooseDateAndTime from './page-choose-date-and-time/component.vue';
import PageCancelPendingOrderedCall from './page-cancel-pending-ordered-call/component.vue';
import PageVirtualDeaprtments from './page-virtual-departments/component.vue';
import PageMissedCall from './page-missed-call/component.vue';
import FormSteps from './form-steps/component.vue';

export default {
  name: 'callweb-modal-window',
  props: ['error', 'widgetModal', 'widgetStyle', 'widgetConfig', 'actualHotlineStatus',
    'todayConnections', 'isHotlineAvailable', 'hotlineDetails', 'hotlineDestinationNumber',
    'widgetIcons', 'editElement', 'asPreview', 'canSendFeedbackAfterConversation'],
  components: {
    'error-messages': ErrorMessage,
    'page-welcome': PageWelcome,
    'page-calling': PageCalling,
    'page-pickup': PagePickup,
    'page-call-end': PageCallEnd,
    'page-leave-message': PageLeaveMessage,
    'page-after-callback': PageAfterCallback,
    'page-choose-date-and-time': PageChooseDateAndTime,
    'page-cancel-pending-ordered-call': PageCancelPendingOrderedCall,
    'page-virtual-departments': PageVirtualDeaprtments,
    'page-missed-call': PageMissedCall,
    'form-steps': FormSteps,
  },
  computed: {
    __hotlineStatusMap() {
      return {
        welcome: {
          component: 'page-welcome',
          title: this.widgetStyle.modal_welcome_message,
          subtitle: 'Wpisz swój numer telefonu',
          showIcon: false,
          icon: null,
        },
        welcome_afterhours: {
          component: 'page-welcome',
          title: this.widgetStyle.modal_welcome_after_hours_message,
          subtitle: 'Wpisz swój numer telefonu',
          showIcon: false,
          icon: null,
        },
        calling: {
          component: 'page-calling',
          title: this.widgetStyle.calling_message,
          subtitle: null,
          showIcon: false,
          icon: null,
        },
        pick_up: {
          component: 'page-pickup',
          title: this.widgetStyle.pick_up_message,
          subtitle: this.widgetStyle.pick_up_submessage,
          showIcon: this.widgetStyle.pick_up_show_icon,
          icon: this.widgetIcons.pick_up,
        },
        connecting: {
          component: 'page-pickup',
          title: this.widgetStyle.connecting_message,
          subtitle: this.widgetStyle.connecting_submessage,
          showIcon: this.widgetStyle.connecting_show_icon,
          icon: this.widgetIcons.connecting,
        },
        talking: {
          component: 'page-pickup',
          title: this.widgetStyle.talking_message,
          subtitle: this.widgetStyle.talking_submessage,
          showIcon: this.widgetStyle.talking_show_icon,
          icon: this.widgetIcons.talking,
        },
        call_end: {
          component: 'page-call-end',
          title: this.widgetStyle.call_end_message,
          subtitle: this.widgetStyle.call_end_submessage,
          showIcon: false,
          icon: null,
        },
        waiting_in_queue: {
          component: 'page-pickup',
          title: this.widgetStyle.waiting_in_queue_message,
          subtitle: this.widgetStyle.waiting_in_queue_submessage,
          showIcon: this.widgetStyle.waiting_in_queue_show_icon,
          icon: this.widgetIcons.waiting_in_queue,
        },
        leave_message: {
          component: 'page-leave-message',
          title: this.widgetStyle.leave_message_message,
          subtitle: this.widgetStyle.leave_message_submessage,
          showIcon: false,
          icon: null,
        },
        choose_date_and_time: {
          component: 'page-choose-date-and-time',
          title: this.widgetStyle.choose_date_and_time_message,
          subtitle: this.widgetStyle.choose_date_and_time_submessage,
          showIcon: false,
          icon: null,
        },
        virtual_departments: {
          component: 'page-virtual-departments',
          title: this.widgetStyle.virtual_departments_message,
          subtitle: this.widgetStyle.virtual_departments_submessage,
          showIcon: false,
          icon: null,
        },
        missed_call: {
          component: 'page-missed-call',
          title: this.widgetStyle.missed_call_message,
          subtitle: this.widgetStyle.missed_call_submessage,
          showIcon: false,
          icon: null,          
        },
        after_callback: {
          component: 'page-after-callback',
          title: this.widgetStyle.after_callback_message,
          subtitle: this.widgetStyle.after_callback_submessage,
          showIcon: false,
          icon: null,
        },
        cancel_pending_ordered_call: {
          component: 'page-cancel-pending-ordered-call',
          title: 'Połączenie oczekujące',
          subtitle: 'Wygląda na to, że dla podanego numeru już widnieje zamówione połączenie',
          showIcon: false,
          icon: null,
        },
      };
    },
    mapHotlineStatusToComponent() {
      return this.__hotlineStatusMap[this.actualHotlineStatus].component;
    },
    mapHotlineStatusToTitle() {
      return this.__hotlineStatusMap[this.actualHotlineStatus];
    },
    mapHotlineStatus() {
      return this.__hotlineStatusMap[this.actualHotlineStatus];
    },
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
      };
    },
    styleForPreview() {
      return {
        position: 'relative !important',
        backgroundColor: 'transparent !important',
        zIndex: '1 !important',
      };
    },
  },
  methods: {
    ...mapActions(['toggleWidgetModal']),
  },
};
